<template>
  <section class="details-insights">
    <IndexView>
      <InsightCard
        v-for="insight in nonQualInsights"
        :key="insight.idx"
        class="insight-card"
        :insight="insight"
        :active-insight-index="activeInsightIndex"
        @click="$emit('selectInsight', insight.idx)"
      >
      </InsightCard>
    </IndexView>
  </section>
</template>

<script>
import InsightCard from './InsightCard.vue'
import IndexView from '@/components/IndexView.vue'

export default {
  components: {
    InsightCard,
    IndexView
  },
  props: ['insights', 'activeInsightIndex', 'showStars'],
  computed: {
    nonQualInsights () {
      return this.insights.filter(insight => {
        const dynamicQual = insight.dynamicQual
        return !dynamicQual
      })
    }
  }
}
</script>

<style scoped>
  .insight-card {
    cursor: pointer;
  }
</style>
